<!-- 상품구매 페이지 -->
<template>
<div id="payment_seat">
    <div class="pay_process">
    <div class="pay_process_wrap">
        <!-- 왼쪽 메뉴 -->
        <div class="progress-bar">
            <div class="bar">
                <div class="_fill"></div>
            </div>
            <div class="point" v-for="(item, index) in left_menu_list" :key="'left_menu'+index" :class="item['active_class']">
                    <div class="bullet">
                    <img :src="item.img_src">
                </div>
                <label class="label">{{item.menu_name}}</label>

            </div>
        </div>
        <!-- 오른쪽 메뉴1 -->
        <div class="process_content">
            <!-- 오른쪽 메뉴2 -->
            <div class="pay_content_wrap">
                <!-- 좌석 타입 선택 -->
                <div class="pay_content_01 pay_content"  v-if="step==2">
                    <div class="paytit">
                    </div>
                    <ul>
                        <li v-for=" (item , index) in mileage_product_list" :key="'pay_content_0'+index" :class="item['active_class']" @click="set_mileage_data(index,item)" >
                            <div>{{item.goods_name}}</div>
                        </li>
                    </ul>
                </div><!-- 좌석 타입 선택 -->

                <!-- 결제 완료 -->
                <div class="pay_content_09 pay_content" v-if="step==6">
                    <div class="finish_payment_wrap">
                        <div class="finish_head">
                            <ul>
                                <li>
                                    <span class="pay_hd">결제금액</span>
                                    <span class="pay_ft">{{last_price_card}} 원</span>
                                </li>
                            </ul>
                        </div>

                        <div class="finish_body">
                            <p>결제가 완료되었습니다.</p>
                            <img src="../../assets/image/barcode_img.jpg">
                            <p>입력하신 휴대폰 번호로 <br><span>결제 정보</span>가 담긴 문자가 전송됩니다.</p>
                        </div>

                        <div class="finish_footer pay_content_btn">
                            <div class="ok_btn" @click="step_finish(-1)">확인</div>
                        </div>
                    </div>
                </div><!-- 결제 완료 -->
            </div><!-- 오른쪽 메뉴2 -->
            <div class="pay_info">
                <div class="pay_info_wrap" v-if="step <= 5">
                    <div class="pay_wrap">
                        <div class="line_top"></div>
                        <ul>
                            <li>
                                <div class="pay_hd">상품명</div>
                                <div class="pay_ft">{{goods_name}}</div>
                            </li>
                            <li>
                                <div class="pay_hd">마일리지</div>
                                <div class="pay_ft">{{charge_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
                            </li>
                            <!-- <li>
                                <span class="pay_hd">상품구분</span>
                                <span class="pay_ft">{{division}}</span>
                            </li>
                            <li>
                                <div class="pay_hd">결제방법</div>
                                <div class="pay_ft">{{pay_type_str}}</div>
                            </li>
                            -->
                            <li>
                                <div class="pay_hd">결제금액</div>
                                <div class="pay_ft price" style="width:54%;">{{last_price_card}}원</div>
                            </li>
                        </ul>
                    </div>
                    <div class="pay_content_btn">
                        <div class="prev_btn" @click="step_controll_back(1)" v-if="step!=7 && step!=8">이전</div>
                        <div class="next_btn" @click="step_controll(3)" v-if="step!=7 && step!=8">다음</div>
                    </div>
                    <div class="pay_content_btn" v-if="step == 5">
                        <div class="prev_btn" @click="step_controll_back(3)">이전</div>
                        <div class="next_btn" @click="do_pay_check()">결제하기</div>
                    </div>
                </div>
            </div>
        </div><!-- 오른쪽 메뉴1 -->
        </div>
    </div><!-- 왼쪽 메뉴 -->
<mileage @milage="milage_payment" style="display:none" />
</div>
</template>

<script>
var self = this;
import vue from 'vue';
import * as config from '../../javascript/config';

// 결제모듈
import external from '@/assets/js/external.js';
import moment from 'vue-moment';

vue.use(moment);
export default {
    data: function () {
        return {
            step: 2,
            left_menu_list: [],
            now_date: '',
            end_date: null,
            end_date_for_server: null,
            user_id: '',

            //결제관련

            time: 'no',

            //////// 마일리지 상품
            mileage_product_list: [],
            mileage_goods_id:'',
            cash: true,
            goods_name:'',
            charge_amount:'',
            card_amount: '',

            division:'',

            //기존에 내가 가지고 있던 마일리지
            my_save_mileage: 0,

            //결제방법
            card_installment: 0, // 0 = 일시불 2 = 2개월 13 = default
            pay_type_str: '카드결제',
            cash_receipt: '0', // 0 == 개인(소득공제) 1 == 법인(지출증빙)
            cash_receipt_flag:false,

            // 내 좌석 상품 , 쿠폰
            my_seat_product_list: [],
            my_coupon_list: [],

            last_price_card: '0',

            // 잔돈 방출 시 다음스텝으로 진행할 지 여부
            payment_return_kind: false,
            // 결제 진행 도중 취소버튼 안보이게
            btn_display_status: "inline-block",

            // 결제 정보 관련
            app_number: 0,         // 승인번호
            payment_kind_name: '',  // 현금 : 종류, 카드 : 카드사명
            card_number: '',        // 카드번호(현금영수증번호)

            special_goods_flag : false // 시간충전권 , 기간권 , 1일시간권 이 아닌 주간권,야간권,주간기간권,야간기간권을 체크하기위한 flag
        }
    },
    filters:{
        coupon_filter(value){
            var num = new Number(value);
            num = num.toFixed(0).replace(/\B(?=(\d{4})+(?!\d))/g, "-");
            return `${num}`
        }
    },
    props: [
        'hot_table',
    ],
    methods: {
        milage_payment(mileage_data, mileage_id) { // 기존의 나의 마일리지 가져오기
            this.mileage_id = mileage_id;
            this.my_save_mileage = mileage_data;
        },
        step_finish() {
            var router = this.$router;
            router.push('/');
        },
        step_controll(val) {
            this.step += val;
            if(this.step == 3 && this.mileage_goods_id == '' ){
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `상품을 선택해주세요.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
                this.step -= 3;
                return;
            }

            if (this.step == 5) {
              this.last_price_card = this.card_amount
            }

            if (this.step == 4) {
                var card = 0;
                card = this.card_amount.replace(/,/g,"");

                let amount = card;

                this.last_price_card = this.card_amount;
        }

        },
        step_controll_back(val) {
            this.step -= val;
            if (this.step == 1) {
                var router = this.$router;
                var last_url = this.$store.getters['get_last_url'];
                if (last_url == undefined ||
                    last_url == null ||
                    last_url == '' ||
                    last_url == 'undefined' ||
                    last_url == 'null' ||
                    last_url.length == 0) {
                    router.push('/');
                } else {
                    router.push(last_url); // 이동 위치를 입력
                }
            }

            if(this.step == 3){
                this.mileage_goods_id = '';
                this.charge_amount = ''
                this.card_amount = ''
                this.last_price_card = ''
                this.division = '';
                for(var i = 0; i<this.mileage_product_list.length; i ++){
                    this.mileage_product_list[i].active_class= "";
                }
            }

        },
        set_mileage_data(index,item) {
            this.goods_name = item.goods_name;
            this.mileage_goods_id = item.mileage_goods_id;
            this.charge_amount = item.charge_amount;
            this.card_amount = item.card_amount;
            this.division = '일반';
            for(var i = 0; i < this.mileage_product_list.length; i++){
                this.mileage_product_list[i].active_class = '';
            }
            this.mileage_product_list[index].active_class = 'pay-content-on';

        },

        do_pay_check(){
            let self = this;
            if(this.last_price_card == 0){
                let result = {
                    "cno" : null,
                    "pay_type" : null
                };
                self.do_pay(result);
            }else{
                // 결제모듈
                var pay_info = {
                    mall_id : this.$store.getters['getStoreInfo'].store_imp_code, // 가맹점 ID
                    // mall_id : 'T5102001', // 가맹점 ID
                    mall_nm : this.$store.getters['getStoreInfo'].store_name, // 가맹점명
                    product_nm : this.goods_name, // 상품이름
                    product_amt : this.last_price_card != 0 ? this.last_price_card.replace(/,/g,"") : this.last_price_card, // 결제금액
                    product_expr : "", // 서비스기간 : YYYYMMDD, 예) 20201231
                    user_id : this.$store.getters['getUser'].user_hp, // 가맹점 고객 ID(가맹점 고객 번호)
                    user_no : this.$store.getters['getUser'].user_id, // 가맹점 고객 일련번호
                    user_nm : this.$store.getters['getUser'].name, // 가맹점 고객명
                    user_phone : this.$store.getters['getUser'].user_hp, // 가맹점 고객 번호
                    sp_user_define1 : this.$store.getters['getStoreInfo'].store_id, // 가맹점 아이디
                    sp_user_define2 : this.$store.getters['getStoreInfo'].store_name // 가맹점 이름
                }
                var callbackTemplate = function(command, result){
                    if(result.res_cd == '0000'){
                        self.do_pay(result);
                    }else{
                        const alert_param = {
                            code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                            message: result.res_msg,
                            router: '',
                        }
                        this.$store.commit('set_popup_type', alert_param);
                    }
                };
                mobileBriddgeConn(pay_info, callbackTemplate);
            }

        },

        do_pay(result) {
            var self = this;

            var payment_kind_code;
            var payment_amount;
            var goods_amount;
            var sale_amount;
            var card_div;

            payment_kind_code = 'CARD';
            payment_amount = this.last_price_card == 0 ? this.last_price_card : this.last_price_card.replace(/,/g,"");
            goods_amount = this.card_amount;
            sale_amount = this.discounted_price_card;
            card_div = this.card_installment // 1 = 일시불 2 = 2개월

            var charge_amount = this.charge_amount;
            var goods_count = (goods_amount.match(/,/g) || []).length;
            var payment_count =  (payment_amount.match(/,/g) || []).length;
            var charge_count =  (charge_amount.match(/,/g) || []).length;
            for(let i = 0; i < goods_count; i++){
                goods_amount = goods_amount.replace(/,/g,"");
            }
            // for(let i = 0; i < payment_count; i++){
            //     payment_amount = payment_amount.replace(/,/g,"");
            // }
            for(let i = 0; i < charge_count; i++){
                charge_amount = charge_amount.replace(/,/g,"");
            }
            var total_amount = Number(this.my_save_mileage) + Number(charge_amount);

            if(!this.cash_receipt_flag){
                this.cash_receipt = '0';
            }
            const type = config.REQ_MILIEAGE_PAYMENT_INSERT;
            const data = {
                data: {
                    purchase_type: 'MILEAGE',
                    mobile_yn: true,

                    purchase:{
                        store_id: '', // 서버단
                        user_id: '', // 서버단
                        mileage_goods_id: self.mileage_goods_id
                    },

                    mileage:{
                        store_id: '', // 서버단
                        user_id: '', // 서버단
                        total_amount: total_amount, // 충전할 금액
                        change_amount: charge_amount, // 충전할 금액
                    },

                    payment:{
                        store_id: '', // 서버단
                        user_id: '', // 서버단
                        sale_id: null,
                        mileage_id: '', // 서버단
                        payment_kind_code: payment_kind_code,
                        payment_kind_name: self.payment_kind_name,
                        payment_status_code: 'COMPLETE',
                        goods_type_code: 'MILEAGE',
                        approval_number: self.app_number,
                        payment_amount: payment_amount * 1,
                        goods_amount: goods_amount * 1,
                        sale_amount: 0,
                        card_div: card_div,
                        card_number: self.card_number,
                        goods_name: self.goods_name,
                        cash_receipt:self.cash_receipt, // 현금 영수증
                        cno: result.cno,
                        pay_type: result.pay_type
                    }
                }
            };
            self.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                self.step_controll(1);
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            // mobileBriddgeConn(pay_info, callbackTemplate);

        },
        // 쿠폰입력
        coupoun_input(type_num){
            if(type_num == 'del'){
                if(this.discount_coupon_code.length != 0){
                    this.discount_coupon_code = this.discount_coupon_code.substr(0, this.discount_coupon_code.length-1);
                }
            }else{
                if(this.discount_coupon_code.length <= 11){
                    this.discount_coupon_code = this.discount_coupon_code + type_num;
                }else{
                    return false;
                }
            }
        },
        get_left_menu(){
            this.left_menu_list =  [];
            this.left_menu_list.push({active_class: "process_on", img_src:  require("../../assets/image/process02_on.png"), menu_name : "상품선택" , nomal_step : 3});
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process05_on.png"), menu_name : "결제" , nomal_step : 6});
            this.left_menu_list.push({active_class: "", img_src:  require("../../assets/image/process06_on.png"), menu_name : "완료" , nomal_step : 7});
        },
    },

    mounted() {
        this.$nextTick(function () {
            // main 쪽 좌석 라커 그룹룸 보여주게할 값 셋팅
            this.$store.commit('change_main_tab_chk', {
                value: 0  // =>0좌석 1 사물함 2 그룹룸
            });


            this.get_left_menu();
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();
            var h = today.getHours();
            var m = today.getMinutes();
            if (h < 10) {
                h = '0' + h;
            }
            if (m < 10) {
                m = '0' + m;
            }
            var currentTime = today.getHours() + "시 " + today.getMinutes() + "분 ";
            var currentTime_server = h + ':' + m + ':' + '00';

            if (dd < 10) {
                dd = '0' + dd
            }

            if (mm < 10) {
                mm = '0' + mm
            }

            this.now_date = today = yyyy + '-' + mm + '-' + dd + ' ' + currentTime_server;
            // 상품구매 아이템 데이터 호출

            //마일리지 상품 리스트
            const type = config.REQ_MILEAGE_GOODS_GET_LIST;
            const data = {
                'store_id': this.$store.state.store_id,
            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(response => {
                this.mileage_product_list = response.data;
                if(this.mileage_product_list.length != 0){
                    for(var i = 0; i < this.mileage_product_list.length; i++){
                        this.mileage_product_list[i].active_class = '';
                    }
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });

        });

    },
    beforeDestroy(){
        this.$store.commit('set_payment_Start', false);
    },
    watch:{
        step(){
            for(var i = 0; i < this.left_menu_list.length; i++){
                this.left_menu_list[i].active_class = '';
                if(this.left_menu_list[i].nomal_step == (this.step+1)){
                    this.left_menu_list[i].img_src = require("../../assets/image/process0"+(this.left_menu_list[i].nomal_step)+"_on.png");
                    this.left_menu_list[i].active_class = 'process_on';
                    for (var n=0; n<i; n++) {
                        this.left_menu_list[n].active_class = 'process_finish';
                    }
                }else{
                    this.left_menu_list[i].img_src = require("../../assets/image/left_ico_0"+(this.left_menu_list[i].nomal_step)+".png");
                }
            }
        }
    }
}
</script>

<style>
</style><style>
.vdp-datepicker .vdp-datepicker__calendar {
    position: relative;
    width: 355%;
    height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/components/page/Payment_mileage.vue